import api from '@/services/api'
import { snakeToCamel } from '../../../utils/object'

export default class ApplicationReportAPI {
  static APPLICATION_REPORT_ENDPOINT = 'application-reports'
  static APPLICATION_REPORT_FILE_ENDPOINT = 'report-files'

  /**
   * Initialize a `ApplicationAPI` instance.
   *
   * @param {class} cls  The class to use to create application objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `ApplicationReportAPI`.
   *
   * @param {class} cls      The class to use to create application report objects.
   **/
  static create(cls) {
    return new ApplicationReportAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one ApplicationReport from the API.
   *
   * @param {String} reportID  Unique ID of the application report to retrieve.
   */
  get(reportID) {
    const url = `${ApplicationReportAPI.APPLICATION_REPORT_ENDPOINT}/${reportID}/`
    //console.log("url:"+url)
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Update a application through the API.
   *
   * @param {ApplicationReport} report data to send to the API.
   */
  update(report, fields = [], excludeFields = []) {
    const url = `${ApplicationReportAPI.APPLICATION_REPORT_ENDPOINT}/${report.id}/`
    const data = this.cls.toAPI(report, fields, excludeFields)
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Get all ApplicationReportFile objects tied to a specific cohort.
   *
   * @param {String} cohortId   ID of the Cohort to pull files for.
   */
  getReportFiles(cohortId) {
    const url = ApplicationReportAPI.APPLICATION_REPORT_FILE_ENDPOINT
    //console.log("url")
    //console.log(url)
    const options = {
      params: {
        cohort: cohortId,
      },
    }
    //console.log("options");
    //console.log(options);
    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => snakeToCamel(data.results))
  }
}
